import type { IntlShape } from 'react-intl';

export const formatActivityTimestamp = (
  intl: IntlShape,
  value: string | Date
) => intl.formatDate(value, { dateStyle: 'medium', timeStyle: 'short' });
